import React from "react";
import { Product } from "@/types/entities";
import {
    Potatoe,
    FermentedFood,
    Jams,
    Sauces,
    DistilledAlcohol,
    SparklingWine,
    Wine,
    OtherBeverage,
    Furniture,
} from "@dippi/icons";

export const classificationCodeToIcon: Record<Product["typeName"], React.ReactNode> = {
    "10.31.14": <Potatoe />,
    "10.39.18": <FermentedFood />,
    "10.39.22": <Jams />,
    "10.84.12": <Sauces />,
    "11.01.10": <DistilledAlcohol />,
    "11.02.11": <SparklingWine />,
    "11.02.12": <Wine />,
    "11.07.19": <OtherBeverage />,
    "31.09.1": <Furniture />,
};
